function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M503.467,149.333h-34.133V115.2h34.133c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533H8.533 c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h34.133v34.133H8.533c-5.12,0-8.533,3.413-8.533,8.533V192 c0,5.12,3.413,8.533,8.533,8.533h8.533v204.8c0,5.12,3.413,8.533,8.533,8.533h85.333c5.12,0,8.533-3.413,8.533-8.533 c0-75.093,61.44-136.533,136.533-136.533s136.533,61.44,136.533,136.533c0,5.12,3.413,8.533,8.533,8.533H486.4 c5.12,0,8.533-3.413,8.533-8.533v-204.8h8.533c5.12,0,8.533-3.413,8.533-8.533v-34.133 C512,152.747,508.587,149.333,503.467,149.333z M418.133,115.2h34.133v34.133h-34.133V115.2z M366.933,115.2h34.133v34.133 h-34.133V115.2z M315.733,115.2h34.133v34.133h-34.133V115.2z M264.533,115.2h34.133v34.133h-34.133V115.2z M213.333,115.2h34.133 v34.133h-34.133V115.2z M162.133,115.2h34.133v34.133h-34.133V115.2z M110.933,115.2h34.133v34.133h-34.133V115.2z M59.733,115.2 h34.133v34.133H59.733V115.2z M51.2,234.667c0-5.12,3.413-8.533,8.533-8.533h34.133c5.12,0,8.533,3.413,8.533,8.533 s-3.413,8.533-8.533,8.533H59.733C54.613,243.2,51.2,239.787,51.2,234.667z M119.467,285.867H85.333 c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h34.133c5.12,0,8.533,3.413,8.533,8.533 C128,282.453,124.587,285.867,119.467,285.867z M426.667,285.867h-34.133c-5.12,0-8.533-3.413-8.533-8.533 c0-5.12,3.413-8.533,8.533-8.533h34.133c5.12,0,8.533,3.413,8.533,8.533C435.2,282.453,431.787,285.867,426.667,285.867z  M452.267,243.2h-34.133c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h34.133c5.12,0,8.533,3.413,8.533,8.533 S457.387,243.2,452.267,243.2z M494.933,183.467H486.4H25.6h-8.533V166.4h477.867V183.467z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgBridge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.63fcee24.svg";
export { ForwardRef as ReactComponent };